export default __webpack_public_path__ + "d225db2f18b31d1b8a9fa8b1f8d5d074.png";